export default "__VITE_ASSET__DEAC2fPq__"